module.exports = __webpack_public_path__ + "img/Classroom 1.8d09aa61.jpg";